import React from 'react';
import { VALIDATION_RULES } from '@constants';
import { Input } from '@ui';
import { Col, Form, Row } from 'antd';

const SecondRow = () => {
    return (
        <Row>
            <Col span={24}>
                <Form.Item name='routingNumber' rules={VALIDATION_RULES.ROUTING_NUMBER}>
                    <Input.Number width='100%' label='Routing number' prefix={null} />
                </Form.Item>
            </Col>
        </Row>
    );
};

export default SecondRow;
